import React, { Component } from 'react'
import { observer } from 'mobx-react'
import './styles.scss'
import '../../styles/index.scss'
import env from '../../env'
import ExclamationTriangleSVG from '../../assets/img/exclamation-triangle.svg'

class FAASubmitSection extends Component {
  handleResetForm = () => {
    this.props.Store.cleanData()
  }

  render () {
    const { sendForm, automationName, Store } = this.props

    return (
      <div>
        <div className='row submit-container'>
          <div className='col-xs-9 col-xxs-12'>
            <button
              type='button'
              id='form-submit'
              className='btn btn-primary btn-block btn-answer enable default-enable'
              data-loading-text='Loading...'
              data-success-text='Submitted!'
              onClick={sendForm}
              disabled={Store.sendingForm}
              data-automation-name={automationName}
            >
              Submit your information
            </button>
          </div>
          <div className='col-xs-3 col-xxs-12 right-container'>
            <div className='btn btn-block btn-reset' onClick={this.handleResetForm}>Reset</div>
          </div>
        </div>
        {
          !Store.valid &&
            <div className='callback invalid-form'>
              <div role='alert' className='alert alert-danger alert-dismissible'>
                <div className='display-flex'>
                  <h6>
                    <img src={ExclamationTriangleSVG} alt='ex-triangle' className='error-icon' />
                    <span> A validation error occurred</span>
                  </h6>
                </div>
                <p data-automation-name='validationMessage'>Please correct the highlighted fields.</p>
              </div>
            </div>
        }
        {
          Store.formHasError && env.REACT_APP_FAA_CRM_INTEGRATION_TOGGLE !== 'on' &&
            <div className='callback server-error'>
              <div role='alert' className='alert alert-danger alert-dismissible'>
                <p>We’re sorry, an error has occurred while processing your request. Please check your network connection and try submitting the application again. If the issue is not resolved, please contact <a href='mailto:access@foundationmedicine.com'>access@foundationmedicine.com</a>.</p>
              </div>
            </div>
        }
      </div>
    )
  }
}

export default observer(FAASubmitSection)
